module.exports = __webpack_public_path__ + "static/media/paypal.5e524852.png";